import React from 'react';
import { TabDescriptor } from '../types';

interface OperationTabsProps {
  descriptors: TabDescriptor[];
  activeIndex: number;
  onSelect: (index: number) => void;
}

const tooltipFor = (tab: TabDescriptor): string => {
  if (tab.inactive) return 'Fonctionnalité en cours de développement';
  if (tab.disabled) return 'Non disponible dans ce statut';
  return '';
};

// Barre d'onglets pilotee par descripteurs types : pas d'index magique, pas de regex.
const OperationTabs: React.FC<OperationTabsProps> = ({ descriptors, activeIndex, onSelect }) => (
  <div className="opbc__tab-nav">
    <div className="opbc__tab-nav-left">
      {descriptors.map((tab, index) => {
        const locked = tab.disabled || tab.inactive;
        const tooltip = tooltipFor(tab);
        const classes = ['opbc__tab-button'];
        if (index === activeIndex) classes.push('active');
        if (tab.inactive) classes.push('inactive');
        if (tab.disabled) classes.push('disabled');

        return (
          <button
            key={tab.key}
            type="button"
            className={classes.join(' ')}
            onClick={() => !locked && onSelect(index)}
            disabled={locked}
            title={tooltip}
            data-tooltip={tooltip}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  </div>
);

export default OperationTabs;
